//* Importing base modules
import { useState, useEffect } from "react";

//* Importing bootstrap components
import { InputGroup } from "react-bootstrap";

//* Importing components
import PasswordInput from "../../../component/base/PasswordInput";
import DefaultButton from "../../../component/base/DefaultButton";

//! Importing APIs
import { AuthAPI } from "../../../services/apis/AuthAPI";
import { setTokenAndMe } from "../../../services/stores/auth/actions";

//* Importing redux
import { useDispatch } from "react-redux";

type ResetPasswordFormProps = {
  setCurrentStep: (step: string) => void;
  email: string;
  message: string;
  setMessage: (message: string) => void;
};

export function ResetPasswordForm({
  setCurrentStep,
  email,
  message,
  setMessage,
}: ResetPasswordFormProps) {
  const [password] = useState<string>("");
  const [passwordConfirmation] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [passwordError, setPasswordError] = useState<string>("");
  const [matchError, setMatchError] = useState<string>("");
  const dispatch = useDispatch();

  const passwordValidation = (password: string) => {
    const errors = [];
    if (password.length < 8) errors.push("Deve ter pelo menos 8 caracteres");
    if (!/[A-Z]/.test(password)) errors.push("Deve conter uma letra maiúscula");
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password))
      errors.push("Deve conter um símbolo especial");

    return errors.join(", ");
  };

  useEffect(() => {
    setPasswordError(passwordValidation(password));
    if (password !== passwordConfirmation) {
      setMatchError("As senhas não coincidem.");
    } else {
      setMatchError("");
    }
  }, [password, passwordConfirmation]);

  const login = async () => {
    setLoading(true);
    setMessage("");
    const response = await AuthAPI.authorize(email, password);
    if (response.result) {
      dispatch(
        setTokenAndMe({
          me: {
            ...response.data.user,
          },
          token: response.data.access.token,
        })
      );
      setMessage("Login realizado com sucesso!");
    } else {
      setMessage(response.message);
    }
    setLoading(false);
  };

  const resetPassword = async () => {
    if (passwordError || matchError) {
      setMessage("Corrija os erros antes de continuar.");
      return;
    }
    setLoading(true);
    setMessage("");
    const response = await AuthAPI.resetPassword(
      email,
      password,
      passwordConfirmation,
    );
    if (response.result) {
      setMessage("Senha redefinida com sucesso. Realizando login...");
      await login();
    } else {
      setMessage(response.message);
    }
    setLoading(false);
  };

  return (
    <form
      className="form-horizontal m-t-30"
      onSubmit={(e) => {
        e.preventDefault();
        resetPassword();
      }}
    >
      <h4 style={{ fontSize: 18 }}>Redefinir Senha</h4>
      <p className="text-muted" style={{ fontSize: 14 }}>
        Crie uma nova senha para a sua conta.
      </p>
      <InputGroup>
        <PasswordInput
          label="Nova Senha"
          placeholder="Digite sua nova senha"
          className="flex1"
          value={password}
          required
        />
        {passwordError && (
          <p style={{ color: "red", fontSize: "0.8rem" }}>{passwordError}</p>
        )}
      </InputGroup>
      <InputGroup>
        <PasswordInput
          label="Confirme a Nova Senha"
          placeholder="Confirme sua nova senha"
          className="flex1"
          value={passwordConfirmation}
          required
        />
        {matchError && (
          <p style={{ color: "red", fontSize: "0.8rem" }}>{matchError}</p>
        )}
      </InputGroup>
      {message && (
        <p
          style={{
            color: message.includes("sucesso") ? "green" : "red",
            fontSize: "0.8rem",
          }}
        >
          {message}
        </p>
      )}
      <DefaultButton
        type="submit"
        bg="primary"
        width="100%"
        height="3rem"
        style={{ marginTop: "15px" }}
        text="Redefinir Senha"
        loadingtext="Redefinindo..."
        loading={loading}
      />
      <div
        style={{
          marginTop: "15px",
          textAlign: "left",
        }}
      >
        <span
          style={{
            fontSize: "0.9rem",
            color: "#007bff",
            cursor: "pointer",
          }}
          onClick={() => setCurrentStep("enterEmail")}
        >
          Voltar
        </span>
      </div>
    </form>
  );
}
